import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import './index.scss';

const MaterialIssuesFilter = ({ onFilterChange, selectedFilter, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const filterOptions = [
    { value: '', label: 'All Templates' },
    { value: 'duplicate', label: 'Duplicate Materials' },
    { value: 'hidden', label: 'Hidden Materials' },
    { value: 'moved', label: 'Moved Materials' },
    { value: 'inactive', label: 'Inactive Materials' },
    { value: 'all', label: 'Any Material Issues' }
  ];

  const handleFilterChange = (filterValue) => {
    onFilterChange(filterValue);
    setIsOpen(false);
  };

  const getFilterLabel = () => {
    const selected = filterOptions.find(option => option.value === selectedFilter);
    return selected ? selected.label : 'All Templates';
  };

  const getFilterIcon = () => {
    if (!selectedFilter) return null;
    
    return (
      <span className="filter-indicator">
        <FilterAltIcon fontSize="small" />
      </span>
    );
  };

  return (
    <div className="material-issues-filter">
      <Dropdown 
        show={isOpen} 
        onToggle={(isOpen) => setIsOpen(isOpen)}
        disabled={disabled}
      >
        <Dropdown.Toggle 
          variant="outline-secondary" 
          className="filter-toggle-btn"
          disabled={disabled}
        >
          {getFilterIcon()}
          {getFilterLabel()}
        </Dropdown.Toggle>

        <Dropdown.Menu className="filter-dropdown-menu">
          {filterOptions.map((option) => (
            <Dropdown.Item
              key={option.value}
              onClick={() => handleFilterChange(option.value)}
              className={selectedFilter === option.value ? 'active' : ''}
            >
              {option.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MaterialIssuesFilter;
